import { Button, Divider, Stack, styled, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Iconify from "../iconify/iconify";
import { useTheme } from "@emotion/react";
import useWindowSize from "../../hooks/useWindowSize";
import { TextEdit } from "./TextEdit";

import CustomSelectIcon from "../utils/CustomSelectIcon";
import axios from "axios";
import { usePropertiesSlug } from "../../hooks/use-data-properties";
import { patch } from "../utils/request";
import { useSearchParams } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";
import { SlackChat } from "../Yoopta/YooptaEdit";

export const PropertyDescriptionEdit = ({ slug }) => {
  const theme = useTheme();
  const { auth } = useAuthStore();
  const borderValue = `1px solid ${theme.palette.divider}`;
  const screenWidth = useWindowSize();
  const { dataPropertiesSlugQuery } = usePropertiesSlug(slug);

  const StyledBorderStack = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    padding: "35px",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
    },
  }));
  const [isEditing, setIsEditing] = useState(false);

  const [descripcionTitle, setDescripcionTitle] = useState(
    dataPropertiesSlugQuery?.data?.description?.descripcionTitle ||
      "Descripción"
  );

  const [descripcion, setDescripcion] = useState(
    dataPropertiesSlugQuery?.data?.description?.descripcion ||
      JSON.stringify({
        "f17bf206-7211-4998-8558-4a271457507d": {
          id: "f17bf206-7211-4998-8558-4a271457507d",
          value: [
            {
              id: "c34166c8-2d27-448d-ba10-deef69a05e6c",
              type: "paragraph",
              children: [{ text: "" }],
              props: { nodeType: "block" },
            },
          ],
          type: "Paragraph",
          meta: { order: 0, depth: 0 },
        },
      })
  );

  const [enseres, setEnseres] = useState(
    dataPropertiesSlugQuery?.data?.description?.enseres || null
  );

  const handleSave = async () => {
    try {
      const data = {
        descripcionTitle,
        descripcion,
        enseres,
      };

      await patch({
        path: `/properties/description/${slug}`,
        data,
        token: auth.accessToken,
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }

    setIsEditing(false);
  };

  return (
    <Stack
      direction="column"
      gap={1}
      position="relative"
      border={`1px solid ${theme.palette.divider}`}
      borderRadius="8px"
      padding="35px"
    >
      {isEditing && (
        <Stack
          direction="row-reverse"
          alignItems="center"
          gap={1}
          position={"absolute"}
          top={10}
          right={10}
        >
          <Iconify
            icon="mdi:content-save"
            sx={{
              cursor: "pointer",
              color: "text.secondary",
              fontSize: 400,
              "&:hover": {
                color: "text.primary", // Cambia color al hover
              },
            }}
            onClick={handleSave}
          />
          {/* <Iconify icon="mdi:content-save" sx={{ color: "text.secondary" }} /> */}
        </Stack>
      )}

      <TextEdit
        variant="subtitle1"
        color="text.secondary"
        content={descripcionTitle}
        onSaveChange={(content) => {
          setDescripcionTitle(content);
          setIsEditing(true);
        }}
      />

      <SlackChat
        initValue={JSON.parse(descripcion)}
        onChange={(s) => {
          setIsEditing(true);
          console.log(JSON.stringify(s));
          setDescripcion(JSON.stringify(s));
        }}
      />
      {/*  <TextEdit
        variant="body1"
        color="text.primary"
        mb={3}
        content={descripcion}
        onSaveChange={(content) => {
          setDescripcion(content);
          setIsEditing(true);
        }}
      /> */}

      <Divider variant="fullWidth" orientation="horizontal" />
      {!!enseres && (
        <Stack
          direction="row"
          flexWrap={{ xs: "wrap", md: "nowrap" }}
          pt={3}
          position={"relative"}
        >
          <Stack
            direction="row-reverse"
            alignItems="center"
            gap={1}
            position={"absolute"}
            top={0}
            right={0}
          >
            <Iconify
              icon="mdi:close"
              sx={{
                cursor: "pointer",
                color: "red",
                fontSize: 400,
                "&:hover": {
                  color: "text.primary", // Cambia color al hover
                },
              }}
              onClick={() => {
                setIsEditing(true);
                setEnseres(null);
              }}
            />
            {/* <Iconify icon="mdi:content-save" sx={{ color: "text.secondary" }} /> */}
          </Stack>

          {enseres.map((value, index, s) => {
            if (index === s.length - 1)
              return (
                <Stack
                  direction="column"
                  gap={1}
                  width={{ xs: "45%", md: "80%" }}
                  pl={2}
                  borderTop={{ xs: borderValue, md: "none" }}
                  pt={{ xs: 2, md: 0 }}
                  mt={screenWidth < 1000 ? 2 : 0}
                >
                  <Stack direction="row" alignItems="center" gap={1}>
                    <CustomSelectIcon
                      defaultChecked={value.icon}
                      onChange={(value) => {
                        const newDescripcion = enseres.map((item, i) => {
                          if (i === index)
                            return {
                              ...item,
                              icon: value,
                            };

                          return item;
                        });
                        setEnseres(newDescripcion);
                        setIsEditing(true);
                      }}
                    />
                    <TextEdit
                      variant="body1"
                      color="text.secondary"
                      content={value.descripcion}
                      onSaveChange={(content) => {
                        const newDescripcion = enseres.map((item, i) => {
                          if (i === index)
                            return {
                              ...item,
                              descripcion: content,
                            };

                          return item;
                        });
                        setEnseres(newDescripcion);
                        setIsEditing(true);
                      }}
                    />
                  </Stack>
                  <TextEdit
                    variant="subtitle2"
                    color="text.secondary"
                    pl="4px"
                    content={value.count}
                    onSaveChange={(content) => {
                      const newDescripcion = enseres.map((item, i) => {
                        if (i === index)
                          return {
                            ...item,
                            count: content,
                          };

                        return item;
                      });
                      setEnseres(newDescripcion);
                      setIsEditing(true);
                    }}
                  />
                </Stack>
              );

            if (index === 0)
              return (
                <Stack
                  direction="column"
                  gap={1}
                  borderRight={borderValue}
                  pr={{ xs: 1, md: 0 }}
                  width={{ xs: "45%", md: "100%" }}
                >
                  <Stack direction="row" alignItems="center" gap={1}>
                    <CustomSelectIcon
                      defaultChecked={value.icon}
                      onChange={(value) => {
                        const newDescripcion = enseres.map((item, i) => {
                          if (i === index)
                            return {
                              ...item,
                              icon: value,
                            };

                          return item;
                        });
                        setEnseres(newDescripcion);
                        setIsEditing(true);
                      }}
                    />

                    <TextEdit
                      variant="body1"
                      color="text.secondary"
                      content={value.descripcion}
                      onSaveChange={(content) => {
                        const newDescripcion = enseres.map((item, i) => {
                          if (i === index)
                            return {
                              ...item,
                              descripcion: content,
                            };

                          return item;
                        });
                        setEnseres(newDescripcion);
                        setIsEditing(true);
                      }}
                    />
                  </Stack>

                  <TextEdit
                    variant="subtitle2"
                    color="text.secondary"
                    pl="4px"
                    content={value.count}
                    onSaveChange={(content) => {
                      const newDescripcion = enseres.map((item, i) => {
                        if (i === index)
                          return {
                            ...item,
                            count: content,
                          };

                        return item;
                      });
                      setEnseres(newDescripcion);
                      setIsEditing(true);
                    }}
                  />
                </Stack>
              );

            return (
              <Stack
                direction="column"
                gap={1}
                borderRight={{ xs: "none", md: borderValue }}
                width={{ xs: "45%", md: "80%" }}
                pl={2}
                pb={{ xs: 2, md: 0 }}
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <CustomSelectIcon
                    defaultChecked={value.icon}
                    onChange={(value) => {
                      const newDescripcion = enseres.map((item, i) => {
                        if (i === index)
                          return {
                            ...item,
                            icon: value,
                          };

                        return item;
                      });
                      setEnseres(newDescripcion);
                      setIsEditing(true);
                    }}
                  />
                  <TextEdit
                    variant="body1"
                    color="text.secondary"
                    content={value.descripcion}
                    onSaveChange={(content) => {
                      const newDescripcion = enseres.map((item, i) => {
                        if (i === index)
                          return {
                            ...item,
                            descripcion: content,
                          };

                        return item;
                      });
                      setEnseres(newDescripcion);
                      setIsEditing(true);
                    }}
                  />
                </Stack>
                <TextEdit
                  variant="subtitle2"
                  color="text.secondary"
                  pl="4px"
                  content={value.count}
                  onSaveChange={(content) => {
                    const newDescripcion = enseres.map((item, i) => {
                      if (i === index)
                        return {
                          ...item,
                          count: content,
                        };

                      return item;
                    });
                    setEnseres(newDescripcion);
                    setIsEditing(true);
                  }}
                />
              </Stack>
            );
          })}
        </Stack>
      )}

      {!enseres && (
        <Stack>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#a95052",
              "&:hover": { backgroundColor: "#8c3e47" },
            }}
            onClick={() => {
              setEnseres([
                {
                  descripcion: "Departamentos de lujo",
                  count: "41",
                  icon: "mdi:office-building-marker-outline",
                },
                {
                  descripcion: "Mirador",
                  count: "01",
                  icon: "mdi:greenhouse",
                },
                {
                  descripcion: "Amenidades",
                  count: "17",
                  icon: "line-md:coffee-half-empty-filled-loop",
                },
                {
                  descripcion: "Local Comercial",
                  count: "01",
                  icon: "mdi:store-check",
                },
              ]);
              setIsEditing(true);
            }}
          >
            + Agregar enseres
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
